import { HeroSection } from "@admin/components/organisms/HeroSection";

import { PersonnelTables } from "./components/PersonnelTables";
// import { Accordion } from "@admin/components/molecules/Accordion";

export default function PersonnelPage() {
  return (
    <>
      <HeroSection />
      <div className="flex flex-col gap-7.5">
        <PersonnelTables />
        {/* <Accordion /> */}
      </div>
    </>
  );
}
